import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import styles from '../../../styles/style-setting.module.scss';

const EditNatureProduct = (props) => {
  const [Open, setOpen] = useState(false);
  const Toggle = () => setOpen(!Open);
  const httpClient = useHttpClient(true);
  const [activities, setActivities] = useState([]);
  const [natureProductUpdate, setNatureProductUpdate] = useState({});
  const [modelEdit, setModelEdit] = useState(false);
  const modelEditToggle = () => resetForm();
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [defaultOptionValue, setDefaultOptionValue] = useState({});
  const [, setProduct] = useState('');
  const [, setDescription] = useState('');
  const [spinner, setSpinner] = useState(false);

  function handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...natureProductUpdate };
    item[name] = value;
    setNatureProductUpdate(item);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    let activitySelected = { id: defaultOptionValue['id'], name: defaultOptionValue['name'] };
    activities.map((activity) => {
      if (activity.name === natureProductUpdate['activity']) {
        activitySelected = { id: activity.id, name: activity.name };
      }
      return activitySelected;
    });

    const natureProductData = {
      id: natureProductUpdate['id'],
      name: natureProductUpdate['name'],
      description: natureProductUpdate['description'],
      activity: activitySelected,
    };
    try {
      if (natureProductUpdate['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        natureProductUpdate['name'] = props.natureproduct['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        const response = httpClient.current?.put(`/api/nature_product/update`, natureProductData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.natureproducts();
          setModelEdit(!modelEdit);
        }
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    natureProductUpdate['name'] = props.natureproduct['name'];
    natureProductUpdate['description'] = props.natureproduct['description'];
    setModelEdit(!modelEdit);
  };

  useEffect(() => {
    const getActivities = () => {
      httpClient.current?.get(`/api/activity/all`).then((response) => {
        setActivities(response.data);
      });
    };
    getActivities();
    setDefaultOptionValue(props.natureproduct.activity);
    setNatureProductUpdate(props.natureproduct);
  }, [httpClient, props.natureproduct]);

  return (
    <>
      <EditButtonIcon
        title={props.t('edit_np')}
        onClick={modelEditToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={modelEdit} toggle={modelEditToggle} centered>
        <ModalHeader>{props.t('edit_np')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <label htmlFor="natureproduct_name">{props.t('np')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="natureproduct_name"
                    value={natureProductUpdate['name']}
                    onChange={(e) => setProduct(e.target.value)}
                    placeholder={props.t('placeholder_nature_product')}
                  />
                </FormGroup>
                <FormGroup className="">
                  <label htmlFor="natureproduct_description">{props.t('Description')}</label>
                  <textarea
                    value={natureProductUpdate['description']}
                    name="description"
                    onChange={(e) => setDescription(e.target.value)}
                    className="form-control"
                    id="natureproduct_description"
                    rows={3}
                    placeholder={props.t('more_details')}
                  ></textarea>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="idActivity">{props.t('activity')}</label>
                  <select
                    name="activity"
                    id="charge_activity"
                    className="form-control"
                    value={defaultOptionValue['name']}
                    onChange={(e) => setDefaultOptionValue(e.target.value)}
                  >
                    {activities.map((activity) => (
                      <option key={activity.id} value={activity.name}>
                        {activity.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <Button outline color="success" className="float-right " type="submit">
                  {props.t('update')}
                </Button>
                <Button color="secondary" className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('Cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};
export default translate(EditNatureProduct);
